import {
  Heading as ChakraHeading,
  HeadingProps as ChakraHeadingProps,
  Text,
  TextProps,
  SpaceProps,
} from '@chakra-ui/react'

import {
  headingSm,
  headingMd,
  headingLg,
  headingXl,
  bodyLg,
  bodySm,
  captionSm,
  captionMd,
  labelLg,
  labelMd,
  labelSm,
} from 'theme/typography'

type ExposedChakraProps = Pick<
  TextProps,
  'color' | 'as' | 'noOfLines' | 'isTruncated'
> &
  SpaceProps

export interface HeadingProps extends ExposedChakraProps {
  size: 'xl' | 'lg' | 'md' | 'sm'
}

export const Heading: React.FC<HeadingProps> = ({
  size,
  color = 'black',
  children,
  ...props
}) => {
  let options: ChakraHeadingProps

  switch (size) {
    case 'xl':
      options = { ...headingXl, as: 'h1' }
      break
    case 'lg':
      options = { ...headingLg, as: 'h2' }
      break
    case 'md':
      options = { ...headingMd, as: 'h3' }
      break
    case 'sm':
      options = { ...headingSm, as: 'h4' }
      break
  }

  return (
    <ChakraHeading {...options} {...props} color={color}>
      {children}
    </ChakraHeading>
  )
}

export interface BodyProps extends ExposedChakraProps {
  size?: 'sm' | 'lg'
}

export const Body: React.FC<BodyProps> = ({
  size = 'lg',
  color = 'charcoal',
  children,
  ...props
}) => {
  let options: TextProps

  switch (size) {
    case 'lg':
      options = bodyLg
      break
    case 'sm':
      options = bodySm
      break
  }

  return (
    <Text {...props} {...options} color={color}>
      {children}
    </Text>
  )
}

export interface CaptionProps extends ExposedChakraProps {
  size?: 'sm' | 'md'
}

export const Caption: React.FC<CaptionProps> = ({
  size = 'sm',
  color = 'offBlack',
  children,
  ...props
}) => {
  let options: TextProps

  switch (size) {
    case 'md':
      options = captionMd
      break
    case 'sm':
      options = captionSm
      break
  }

  return (
    <Text {...props} {...options} color={color}>
      {children}
    </Text>
  )
}

export interface LabelProps extends ExposedChakraProps {
  size: 'lg' | 'md' | 'sm'
}

export const Label: React.FC<LabelProps> = ({
  size,
  color = 'dark',
  children,
  ...props
}) => {
  let options: TextProps

  switch (size) {
    case 'lg':
      options = labelLg
      break
    case 'md':
      options = labelMd
      break
    case 'sm':
      options = labelSm
      break
  }

  return (
    <Text {...props} {...options} color={color}>
      {children}
    </Text>
  )
}
